module.exports = __webpack_public_path__ + "media/images/appIcon-6ae71625c97b666ecd8714454cbb6fb0.png";